import { AvatarSelectorProps } from '..';
import { createUseTextLocalizer } from '../../../locale/createUseTextLocalizer';
import bundle from '../NovaComponents-AvatarSelector-gui-icu.properties';
import { useAvatarA11yInfo } from '../../Avatar/__internal__/useAvatarA11yInfo';
import { useImageSelectorA11yInfo } from '../../ImageSelector/__internal__/useImageSelectorA11yInfo';
import { AvatarDataProvider } from '../../Avatar';

const useTextLocalizer = createUseTextLocalizer(bundle);

export const useAvatarSelectorA11yInfo = (
  props: Pick<
    AvatarSelectorProps,
    'ariaLabel' | 'tooltip' | 'type' | 'userId' | 'imageSelectorProps'
  > & {
    dataProvider: AvatarDataProvider;
  }
): {
  ariaLabel: string;
  tooltip: string;
} => {
  const localize = useTextLocalizer();
  const getImageSelectorA11yInfo = useImageSelectorA11yInfo();
  const {
    ariaLabel: imageSelectorAriaLabel,
    tooltip: imageSelectorTooltip,
  } = getImageSelectorA11yInfo({
    ariaLabel: props.imageSelectorProps?.ariaLabel,
    tooltip: props.imageSelectorProps?.tooltip,
  });
  const {
    ariaLabel: avatarAriaLabel,
    tooltip: avatarTooltip,
    name: avatarName,
  } = useAvatarA11yInfo({
    type: props.type,
    userId: props.userId,
    useAsButton: true,
    dataProvider: props.dataProvider,
  });

  return {
    ariaLabel:
      props.ariaLabel ??
      (avatarName === undefined // When avatar is still loading, do not append imageSelectorAriaLabel
        ? avatarAriaLabel ?? ''
        : localize('avatar.button.aria', {
            avatarAriaLabel: avatarAriaLabel!, // avatarAriaLabel will not be undefined since useAsButton is true
            imageSelectorAriaLabel,
          })),
    tooltip:
      props.tooltip ??
      (avatarName === undefined // When avatar is still loading, do not append imageSelectorTooltip
        ? avatarTooltip ?? ''
        : localize('avatar.button.tooltip.label', {
            avatarTooltip: avatarTooltip!, // avatarTooltip will not be undefined since useAsButton is true
            imageSelectorTooltip,
          })),
  };
};
